/**
 * What a RESELLER node shows in place of the brand modes (ORDR-194).
 *
 * A reseller has no brand, location or site in ordering, so the menu, the
 * hours and the orders belong to a restaurant it signed. Those are reached by
 * switching business, which is the switcher above the shell (ORDR-184): this
 * points at it rather than drawing a screen with nothing to act on.
 */

import type { ReactElement } from "react";

export const RESELLER_POINTER = "Choose a business to manage its menu, hours and orders";

export function ResellerPointer(): ReactElement {
  return (
    <p data-testid="reseller-pointer" className="p-4 text-sm">
      <a
        href="#business-switcher"
        className="inline-flex min-h-11 items-center underline underline-offset-2 text-[var(--color-primary-700)]"
      >
        {RESELLER_POINTER}
      </a>
    </p>
  );
}
